import React, { useState, useEffect } from "react";
const RadioBox = ({ options, selected, onChange, questionKey }) => {
    const [selectedOption, setSelectedOption] = useState(
        selected[questionKey] || null
    );
    useEffect(() => {
        setSelectedOption(selected[questionKey] || null);
    }, [questionKey, selected]);
    const handleOptionChange = (optionValue) => {
        let array = [optionValue];
        setSelectedOption(array);
        onChange(questionKey, array);
    };
    return (
        <div className="option-box-outer">
            {options.map((option, index) => (
                <div key={index} className="option-box">
                    <label className="option-label">
                        <div className="input-container">
                            <input
                                type="radio"
                                name={questionKey}
                                value={option.PK_ID}
                                checked={selectedOption != null ? selectedOption[0] === option.PK_ID : ''}
                                onChange={() => handleOptionChange(option.PK_ID)}
                            />
                            {option.VALUE}
                        </div>
                    </label>
                </div>
            ))}
        </div>
    );
};
export default RadioBox;